<style scoped>
.two-part {
  width: 50%;
  padding: 10px;
}
.form-group:not([class*=' col-']) {
  width: 100%;
  width: 33.333333%;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: -5px;
  padding-bottom: -5px;
}
.fixHeightScrollable {
  overflow: auto;
  height: 500px;
}
</style>

<template>
  <div>
    <b-form validated @submit="onSubmit" @reset="onReset">
      <div class="d-flex justify-content-between">
        <h5></h5>
        <div>
          <b-button-group v-if="editableOps">
            <b-button type="submit" variant="outline-primary" size="sm"
              >Save</b-button
            >
            <b-button type="reset" variant="outline-danger" size="sm"
              >Reset</b-button
            >
          </b-button-group>
        </div>
      </div>
    </b-form>
    <br />
    <div class="overflow-auto">
      <div>
        <hr />
        <div class="fixHeightScrollable">
          <hr />
          <h5 align="center">General</h5>
          <hr />
          <h6>GENERAL</h6>
          <hr />
          <b-form-group
            id="input-group-contractor"
            label="Contractor:"
            label-for="input-contractor"
          >
            <b-form-input
              id="input-contractor"
              v-model="form.contractor"
              type="text"
              placeholder="Enter Contractor"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-supervisor"
            label="Supervisor:"
            label-for="input-supervisor"
          >
            <b-form-input
              id="input-supervisor"
              v-model="form.supervisor"
              type="text"
              placeholder="Enter Supervisor"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-testNo"
            label="Test no:"
            label-for="input-testNo"
          >
            <b-form-input
              id="input-testNo"
              v-model="form.testNo"
              type="number"
              step="0.001"
              placeholder="Enter Test no"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-runNo"
            label="Run no:"
            label-for="input-runNo"
          >
            <b-form-input
              id="input-runNo"
              v-model="form.runNo"
              type="number"
              step="0.001"
              placeholder="Enter Run no"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-testMethod"
            label="Test method:"
            label-for="input-testMethod"
          >
            <b-form-select
              id="input-testMethod"
              v-model="form.testMethod"
              type="text"
              placeholder="Enter Test method"
              :options="optionComboTestMethod"
              :disabled="!editable"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            id="input-group-testPressType"
            label="Test press Type:"
            label-for="input-testPressType"
          >
            <b-form-select
              id="input-testPressType"
              v-model="form.testPressType"
              type="text"
              placeholder="Enter Test press Type"
              :options="optionComboTestPressureType"
              :disabled="!editable"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            id="input-group-testTypeGovCode"
            label="Test type gov code:"
            label-for="input-testTypeGovCode"
          >
            <b-form-input
              id="input-testTypeGovCode"
              v-model="form.testTypeGovCode"
              type="text"
              placeholder="Enter Test type gov code"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-testStartDateTime"
            label="Test start date time:"
            label-for="input-testStartDateTime"
          >
            <b-form-input
              id="input-testStartDateTime"
              v-model="form.testStartDateTime"
              type="datetime-local"
              placeholder="Enter Test start date time"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-testEndDateTime"
            label="Test end date time:"
            label-for="input-testEndDateTime"
          >
            <b-form-input
              id="input-testEndDateTime"
              v-model="form.testEndDateTime"
              type="datetime-local"
              placeholder="Enter Test end date time"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-fluidDisposition"
            label="Fluid disposition:"
            label-for="input-fluidDisposition"
          >
            <b-form-select
              id="input-fluidDisposition"
              v-model="form.fluidDisposition"
              type="text"
              placeholder="Enter Fluid disposition"
              :options="optionComboTestFluidDisposition"
              :disabled="!editable"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            id="input-group-totalLoadToRecover"
            label="Total load to recover:"
            label-for="input-totalLoadToRecover"
          >
            <b-form-input
              id="input-totalLoadToRecover"
              v-model="form.totalLoadToRecover"
              type="number"
              step="0.001"
              placeholder="Enter Total load to recover"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <hr />
          <h5 align="center">Wellbore</h5>
          <hr />
          <b-form-group
            id="input-group-intervalTopMd"
            label="Interval top MD:"
            label-for="input-intervalTopMd"
          >
            <b-form-input
              id="input-intervalTopMd"
              v-model="form.intervalTopMd"
              type="number"
              step="0.001"
              placeholder="Enter Interval top MD"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-intervalBaseMd"
            label="Interval base MD:"
            label-for="input-intervalBaseMd"
          >
            <b-form-input
              id="input-intervalBaseMd"
              v-model="form.intervalBaseMd"
              type="number"
              step="0.001"
              placeholder="Enter Interval base MD"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-mpp"
            label="MPP:"
            label-for="input-mpp"
          >
            <b-form-input
              id="input-mpp"
              v-model="form.mpp"
              type="number"
              step="0.001"
              placeholder="Enter MPP"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-tubingSize"
            label="Tubing size:"
            label-for="input-tubingSize"
          >
            <b-form-input
              id="input-tubingSize"
              v-model="form.tubingSize"
              type="number"
              step="0.001"
              placeholder="Enter Tubing size"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-flowPath"
            label="Flow path:"
            label-for="input-flowPath"
          >
            <b-form-select
              id="input-flowPath"
              v-model="form.flowPath"
              type="text"
              placeholder="Enter Flow path"
              :options="optionComboTestFlowPath"
              :disabled="!editable"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            id="input-group-testSurfaceTemp"
            label="Test surface temp:"
            label-for="input-testSurfaceTemp"
          >
            <b-form-input
              id="input-testSurfaceTemp"
              v-model="form.testSurfaceTemp"
              type="number"
              step="0.001"
              placeholder="Enter Test surface temp"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-barometricPress"
            label="Barometric press:"
            label-for="input-barometricPress"
          >
            <b-form-input
              id="input-barometricPress"
              v-model="form.barometricPress"
              type="number"
              step="0.001"
              placeholder="Enter Barometric press"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-intervalTopTvd"
            label="Interval top TVD:"
            label-for="input-intervalTopTvd"
          >
            <b-form-input
              id="input-intervalTopTvd"
              v-model="form.intervalTopTvd"
              type="number"
              step="0.001"
              placeholder="Enter Interval top TVD"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-intervalBaseTvd"
            label="Interval base TVD:"
            label-for="input-intervalBaseTvd"
          >
            <b-form-input
              id="input-intervalBaseTvd"
              v-model="form.intervalBaseTvd"
              type="number"
              step="0.001"
              placeholder="Enter Interval base TVD"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-flowThrough"
            label="Flow through:"
            label-for="input-flowThrough"
          >
            <b-form-input
              id="input-flowThrough"
              v-model="form.flowThrough"
              type="text"
              placeholder="Enter Flow through"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-averageAnnualTemperature"
            label="Average annual temperature:"
            label-for="input-averageAnnualTemperature"
          >
            <b-form-input
              id="input-averageAnnualTemperature"
              v-model="form.averageAnnualTemperature"
              type="number"
              step="0.001"
              placeholder="Enter Average annual temperature"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-reservoirTemp"
            label="Reservoir temp:"
            label-for="input-reservoirTemp"
          >
            <b-form-input
              id="input-reservoirTemp"
              v-model="form.reservoirTemp"
              type="number"
              step="0.001"
              placeholder="Enter Reservoir temp"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-tubingSetMd"
            label="Tubing set MD:"
            label-for="input-tubingSetMd"
          >
            <b-form-input
              id="input-tubingSetMd"
              v-model="form.tubingSetMd"
              type="number"
              step="0.001"
              placeholder="Enter Tubing set MD"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <hr />
          <h5 align="center">Test Summary</h5>
          <p><b>Shut in information</b></p>
          <hr />
          <b-form-group
            id="input-group-shutInDateTime"
            label="Shut in date time:"
            label-for="input-shutInDateTime"
          >
            <b-form-input
              id="input-shutInDateTime"
              v-model="form.shutInDateTime"
              type="datetime-local"
              placeholder="Enter Shut in date time"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-duration"
            label="Duration:"
            label-for="input-duration"
          >
            <b-form-input
              id="input-duration"
              v-model="form.duration"
              type="number"
              step="0.001"
              placeholder="Enter Duration"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-pressShutIn"
            label="Press Shut in:"
            label-for="input-pressShutIn"
          >
            <b-form-input
              id="input-pressShutIn"
              v-model="form.pressShutIn"
              type="number"
              step="0.001"
              placeholder="Enter Press Shut in"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-tempShutIn"
            label="Temp Shut in:"
            label-for="input-tempShutIn"
          >
            <b-form-input
              id="input-tempShutIn"
              v-model="form.tempShutIn"
              type="number"
              step="0.001"
              placeholder="Enter Temp Shut in"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>

          <p><b>Prior Production</b></p>

          <b-form-group
            id="input-group-producedPrior"
            label="Produced prior:"
            label-for="input-producedPrior"
          >
            <b-form-checkbox
              id="input-producedPrior"
              v-model="form.producedPrior"
              type="number"
              step="0.001"
              placeholder="Enter Produced prior"
              :value="1"
              :unchecked-value="0"
              :disabled="!editable"
              @change="producedPriorChanged"
              >Yes</b-form-checkbox
            >
          </b-form-group>
          <b-form-group
            id="input-group-productionDate"
            label="Production date:"
            label-for="input-productionDate"
          >
            <b-form-input
              id="input-productionDate"
              v-model="form.productionDate"
              type="number"
              step="0.001"
              placeholder="Enter Production date"
              :disabled="!checkedProducedPrior"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-oilRate"
            label="Oil rate:"
            label-for="input-oilRate"
          >
            <b-form-input
              id="input-oilRate"
              v-model="form.oilRate"
              type="number"
              step="0.001"
              placeholder="Enter Oil rate"
              :disabled="!checkedProducedPrior"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-gasRate"
            label="Gas rate:"
            label-for="input-gasRate"
          >
            <b-form-input
              id="input-gasRate"
              v-model="form.gasRate"
              type="number"
              step="0.001"
              placeholder="Enter Gas rate"
              :disabled="!checkedProducedPrior"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-waterRate"
            label="Water rate:"
            label-for="input-waterRate"
          >
            <b-form-input
              id="input-waterRate"
              v-model="form.waterRate"
              type="number"
              step="0.001"
              placeholder="Enter Water rate"
              :disabled="!checkedProducedPrior"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-steamRate"
            label="Steam rate:"
            label-for="input-steamRate"
          >
            <b-form-input
              id="input-steamRate"
              v-model="form.steamRate"
              type="number"
              step="0.001"
              placeholder="Enter Steam rate"
              :disabled="!checkedProducedPrior"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-flowDuration"
            label="Flow duration:"
            label-for="input-flowDuration"
          >
            <b-form-input
              id="input-flowDuration"
              v-model="form.flowDuration"
              type="number"
              step="0.001"
              placeholder="Enter Flow duration"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-initialCasingPress"
            label="Initial casing press:"
            label-for="input-initialCasingPress"
          >
            <b-form-input
              id="input-initialCasingPress"
              v-model="form.initialCasingPress"
              type="number"
              step="0.001"
              placeholder="Enter Initial casing press"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-finalCasingPress"
            label="Final casing press:"
            label-for="input-finalCasingPress"
          >
            <b-form-input
              id="input-finalCasingPress"
              v-model="form.finalCasingPress"
              type="number"
              step="0.001"
              placeholder="Enter Final casing press"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-casingPressLow"
            label="Casing press Low:"
            label-for="input-casingPressLow"
          >
            <b-form-input
              id="input-casingPressLow"
              v-model="form.casingPressLow"
              type="number"
              step="0.001"
              placeholder="Enter Casing press Low"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-wellFlowEfficiencyFactor"
            label="Well flow efficiency factor:"
            label-for="input-wellFlowEfficiencyFactor"
          >
            <b-form-input
              id="input-wellFlowEfficiencyFactor"
              v-model="form.wellFlowEfficiencyFactor"
              type="number"
              step="0.001"
              placeholder="Enter Well flow efficiency factor"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-skinFactor"
            label="Skin factor:"
            label-for="input-skinFactor"
          >
            <b-form-input
              id="input-skinFactor"
              v-model="form.skinFactor"
              type="number"
              step="0.001"
              placeholder="Enter Skin factor"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-analyst"
            label="Analyst:"
            label-for="input-analyst"
          >
            <b-form-input
              id="input-analyst"
              v-model="form.analyst"
              type="text"
              placeholder="Enter Analyst"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-packeType"
            label="Packe type:"
            label-for="input-packeType"
          >
            <b-form-input
              id="input-packeType"
              v-model="form.packeType"
              type="text"
              placeholder="Enter Packe type"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-displacementOfFluids"
            label="Displacement of fluids:"
            label-for="input-displacementOfFluids"
          >
            <b-form-input
              id="input-displacementOfFluids"
              v-model="form.displacementOfFluids"
              type="text"
              placeholder="Enter Displacement of fluids"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-initialTubingPress"
            label="Initial tubing press:"
            label-for="input-initialTubingPress"
          >
            <b-form-input
              id="input-initialTubingPress"
              v-model="form.initialTubingPress"
              type="number"
              step="0.001"
              placeholder="Enter Initial tubing press"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-finalTubingPress"
            label="Final tubing press:"
            label-for="input-finalTubingPress"
          >
            <b-form-input
              id="input-finalTubingPress"
              v-model="form.finalTubingPress"
              type="number"
              step="0.001"
              placeholder="Enter Final tubing press"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-tubingPressLow"
            label="Tubing press low:"
            label-for="input-tubingPressLow"
          >
            <b-form-input
              id="input-tubingPressLow"
              v-model="form.tubingPressLow"
              type="number"
              step="0.001"
              placeholder="Enter Tubing press low"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-kh"
            label="KH:"
            label-for="input-kh"
          >
            <b-form-input
              id="input-kh"
              v-model="form.kh"
              type="number"
              step="0.001"
              placeholder="Enter KH"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-liftInput"
            label="Lift input:"
            label-for="input-liftInput"
          >
            <b-form-input
              id="input-liftInput"
              v-model="form.liftInput"
              type="number"
              step="0.001"
              placeholder="Enter Lift input"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-pumpMd"
            label="Pump MD:"
            label-for="input-pumpMd"
          >
            <b-form-input
              id="input-pumpMd"
              v-model="form.pumpMd"
              type="number"
              step="0.001"
              placeholder="Enter Pump MD"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-sandProduced"
            label="Sand produced:"
            label-for="input-sandProduced"
          >
            <b-form-checkbox
              id="input-sandProduced"
              v-model="form.sandProduced"
              type="number"
              step="0.001"
              placeholder="Enter Sand produced"
              :value="1"
              :unchecked-value="0"
              :disabled="!editable"
            ></b-form-checkbox>
          </b-form-group>
          <b-form-group
            id="input-group-packerTmd"
            label="Packer TMD:"
            label-for="input-packerTmd"
          >
            <b-form-input
              id="input-packerTmd"
              v-model="form.packerTmd"
              type="number"
              step="0.001"
              placeholder="Enter Packer TMD"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-totalTankVolume"
            label="Total tank volume:"
            label-for="input-totalTankVolume"
          >
            <b-form-input
              id="input-totalTankVolume"
              v-model="form.totalTankVolume"
              type="number"
              step="0.001"
              placeholder="Enter Total tank volume"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-pillTankVolume"
            label="Pill tank volume:"
            label-for="input-pillTankVolume"
          >
            <b-form-input
              id="input-pillTankVolume"
              v-model="form.pillTankVolume"
              type="number"
              step="0.001"
              placeholder="Enter Pill tank volume"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <hr />
          <h5 align="center">Injection</h5>
          <hr />
          <b-form-group
            id="input-group-injection"
            label="Injection:"
            label-for="input-injection"
          >
            <b-form-checkbox
              id="input-injection"
              v-model="form.injection"
              type="number"
              step="0.001"
              placeholder="Enter Injection"
              :value="1"
              :unchecked-value="0"
              :disabled="!editable"
              @change="injectionChanged"
              >Yes</b-form-checkbox
            >
          </b-form-group>
          <b-form-group
            id="input-group-type"
            label="Type:"
            label-for="input-type"
          >
            <b-form-input
              id="input-type"
              v-model="form.type"
              type="text"
              placeholder="Enter Type"
              :disabled="!checkedInjection"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-temp"
            label="Temp:"
            label-for="input-temp"
          >
            <b-form-input
              id="input-temp"
              v-model="form.temp"
              type="number"
              step="0.001"
              placeholder="Enter Temp"
              :disabled="!checkedInjection"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-press"
            label="Press:"
            label-for="input-press"
          >
            <b-form-input
              id="input-press"
              v-model="form.press"
              type="number"
              step="0.001"
              placeholder="Enter Press"
              :disabled="!checkedInjection"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-gasVolume"
            label="Gas volume:"
            label-for="input-gasVolume"
          >
            <b-form-input
              id="input-gasVolume"
              v-model="form.gasVolume"
              type="number"
              step="0.001"
              placeholder="Enter Gas volume"
              :disabled="!checkedInjection"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-liquidVolume"
            label="Liquid volume:"
            label-for="input-liquidVolume"
          >
            <b-form-input
              id="input-liquidVolume"
              v-model="form.liquidVolume"
              type="number"
              step="0.001"
              placeholder="Enter Liquid volume"
              :disabled="!checkedInjection"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-gasRateInjection"
            label="Gas rate Injection:"
            label-for="input-gasRateInjection"
          >
            <b-form-input
              id="input-gasRateInjection"
              v-model="form.gasRateInjection"
              type="number"
              step="0.001"
              placeholder="Enter Gas rate Injection"
              :disabled="!checkedInjection"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-liquidRate"
            label="Liquid rate:"
            label-for="input-liquidRate"
          >
            <b-form-input
              id="input-liquidRate"
              v-model="form.liquidRate"
              type="number"
              step="0.001"
              placeholder="Enter Liquid rate"
              :disabled="!checkedInjection"
            ></b-form-input>
          </b-form-group>

          <hr />
          <h5 align="center">Final Rates</h5>
          <hr />
          <b-form-group
            id="input-group-finalOilProdRate"
            label="Final oil prod rate:"
            label-for="input-finalOilProdRate"
          >
            <b-form-input
              id="input-finalOilProdRate"
              v-model="form.finalOilProdRate"
              type="number"
              step="0.001"
              placeholder="Enter Final oil prod rate"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-finalGasProdRate"
            label="Final gas prod rate:"
            label-for="input-finalGasProdRate"
          >
            <b-form-input
              id="input-finalGasProdRate"
              v-model="form.finalGasProdRate"
              type="number"
              step="0.001"
              placeholder="Enter Final gas prod rate"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-finalCondProdRate"
            label="Final cond prod rate:"
            label-for="input-finalCondProdRate"
          >
            <b-form-input
              id="input-finalCondProdRate"
              v-model="form.finalCondProdRate"
              type="number"
              step="0.001"
              placeholder="Enter Final cond prod rate"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-combinedGasCondRate"
            label="Combined gas cond rate:"
            label-for="input-combinedGasCondRate"
          >
            <b-form-input
              id="input-combinedGasCondRate"
              v-model="form.combinedGasCondRate"
              type="number"
              step="0.001"
              placeholder="Enter Combined gas cond rate"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-finalWaterProdRate"
            label="Final water prod rate:"
            label-for="input-finalWaterProdRate"
          >
            <b-form-input
              id="input-finalWaterProdRate"
              v-model="form.finalWaterProdRate"
              type="number"
              step="0.001"
              placeholder="Enter Final water prod rate"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-wellBlowDuration"
            label="Well blow duration:"
            label-for="input-wellBlowDuration"
          >
            <b-form-input
              id="input-wellBlowDuration"
              v-model="form.wellBlowDuration"
              type="number"
              step="0.001"
              placeholder="Enter Well blow duration"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-sprayClearDuration"
            label="Spray clear duration:"
            label-for="input-sprayClearDuration"
          >
            <b-form-input
              id="input-sprayClearDuration"
              v-model="form.sprayClearDuration"
              type="number"
              step="0.001"
              placeholder="Enter Spray clear duration"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-oilDensity"
            label="Oil density:"
            label-for="input-oilDensity"
          >
            <b-form-input
              id="input-oilDensity"
              v-model="form.oilDensity"
              type="number"
              step="0.001"
              placeholder="Enter Oil density"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-gasDensity"
            label="Gas density:"
            label-for="input-gasDensity"
          >
            <b-form-input
              id="input-gasDensity"
              v-model="form.gasDensity"
              type="number"
              step="0.001"
              placeholder="Enter Gas density"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>

          <hr />
          <h5 align="center">Result</h5>
          <hr />
          <b-form-group
            id="input-group-stabFlowRate"
            label="Stab flow rate:"
            label-for="input-stabFlowRate"
          >
            <b-form-input
              id="input-stabFlowRate"
              v-model="form.stabFlowRate"
              type="number"
              step="0.001"
              placeholder="Enter Stab flow rate"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-pfsf"
            label="PFSF:"
            label-for="input-pfsf"
          >
            <b-form-input
              id="input-pfsf"
              v-model="form.pfsf"
              type="number"
              step="0.001"
              placeholder="Enter PFSF"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-pfwf"
            label="PFWF:"
            label-for="input-pfwf"
          >
            <b-form-input
              id="input-pfwf"
              v-model="form.pfwf"
              type="number"
              step="0.001"
              placeholder="Enter PFWF"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-snsf"
            label="SNSF:"
            label-for="input-snsf"
          >
            <b-form-input
              id="input-snsf"
              v-model="form.snsf"
              type="number"
              step="0.001"
              placeholder="Enter SNSF"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-snwh"
            label="SNWH:"
            label-for="input-snwh"
          >
            <b-form-input
              id="input-snwh"
              v-model="form.snwh"
              type="number"
              step="0.001"
              placeholder="Enter SNWH"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-extFlowSandfacePress"
            label="Ext flow sandface press:"
            label-for="input-extFlowSandfacePress"
          >
            <b-form-input
              id="input-extFlowSandfacePress"
              v-model="form.extFlowSandfacePress"
              type="number"
              step="0.001"
              placeholder="Enter Ext flow sandface press"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-extFlowWellheadPress"
            label="Ext flow wellhead press:"
            label-for="input-extFlowWellheadPress"
          >
            <b-form-input
              id="input-extFlowWellheadPress"
              v-model="form.extFlowWellheadPress"
              type="number"
              step="0.001"
              placeholder="Enter Ext flow wellhead press"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-ensf"
            label="ENSF:"
            label-for="input-ensf"
          >
            <b-form-input
              id="input-ensf"
              v-model="form.ensf"
              type="number"
              step="0.001"
              placeholder="Enter ENSF"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-avgReservoirPress"
            label="Avg reservoir press:"
            label-for="input-avgReservoirPress"
          >
            <b-form-input
              id="input-avgReservoirPress"
              v-model="form.avgReservoirPress"
              type="number"
              step="0.001"
              placeholder="Enter Avg reservoir press"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-reservoirPressComments"
            label="Reservoir press comments:"
            label-for="input-reservoirPressComments"
          >
            <b-form-input
              id="input-reservoirPressComments"
              v-model="form.reservoirPressComments"
              type="text"
              placeholder="Enter Reservoir press comments"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-avgReservoirPressTvd"
            label="Avg reservoir press TVD:"
            label-for="input-avgReservoirPressTvd"
          >
            <b-form-input
              id="input-avgReservoirPressTvd"
              v-model="form.avgReservoirPressTvd"
              type="number"
              step="0.001"
              placeholder="Enter Avg reservoir press TVD"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-reservoirPotentialCondensate"
            label="Reservoir potential condensate:"
            label-for="input-reservoirPotentialCondensate"
          >
            <b-form-input
              id="input-reservoirPotentialCondensate"
              v-model="form.reservoirPotentialCondensate"
              type="number"
              step="0.001"
              placeholder="Enter Reservoir potential condensate"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-sandfacePressComments"
            label="Sandface press comments:"
            label-for="input-sandfacePressComments"
          >
            <b-form-input
              id="input-sandfacePressComments"
              v-model="form.sandfacePressComments"
              type="text"
              placeholder="Enter Sandface press comments"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-staticWellheadPress"
            label="Static wellhead press:"
            label-for="input-staticWellheadPress"
          >
            <b-form-input
              id="input-staticWellheadPress"
              v-model="form.staticWellheadPress"
              type="number"
              step="0.001"
              placeholder="Enter Static wellhead press"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-stabWellheadPress"
            label="Stab wellhead press:"
            label-for="input-stabWellheadPress"
          >
            <b-form-input
              id="input-stabWellheadPress"
              v-model="form.stabWellheadPress"
              type="number"
              step="0.001"
              placeholder="Enter Stab wellhead press"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>

          <hr />
          <h5 align="center">Remarks</h5>
          <hr />
          <b-form-group
            id="input-group-remarks"
            label="Remarks:"
            label-for="input-remarks"
            style="width: 100%"
          >
            <b-form-textarea
              id="input-remarks"
              v-model="form.remarks"
              type="text"
              rows="5"
              placeholder="Enter Remarks"
              :disabled="!editable"
            ></b-form-textarea>
          </b-form-group>
        </div>
        <hr />
      </div>

      <!-- <p>{{ selectedRow }}</p> -->
    </div>
  </div>

  <!-- MODALS -->
</template>

<script>
import Vue from 'vue'
import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import { formMethods, formComputed } from '@state/helpers'
import notify from "devextreme/ui/notify"

Vue.use(VueFormGenerator)

export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    submitId: {type: Number, default: undefined},
    editable: Boolean,
  },
  data() {
    return {
      form: [],
      show: true,
      hasData: false,
      editableOps: this.editable,
      optionComboTestMethod: [],
      optionComboTestPressureType: [],
      optionComboTestFluidDisposition: [],
      optionComboTestFlowPath: [],
      checkedProducedPrior: false,
      checkedInjection: false,
    }
  },
  computed: {
    ...formComputed,
  },
  watch: {
    submitId: function (value) {
      this.init()
    },
    editable: function (val) {
      this.editableOps = val
    },
  },
  created: function () {
    this.init()
  },
  methods: {
    ...formMethods,
    init() {
      this.loadAllCombo()
      this.form = []
      this.getActivityWellTest({
        params: { submitId: this.submitId },
      }).then((resp) => {
        if (resp.data.data.length > 0) {
          this.hasData = true
          this.form = resp.data.data[0]
        }
        console.log('this.hasData', this.hasData)
      })
    },
    loadAllCombo() {
      this.optionComboTestMethod = []
      this.optionComboTestPressureType = []
      this.optionComboTestFluidDisposition = []
      this.optionComboTestFlowPath = []

      let dataCombo = [
        { option: 1, combo_name: 'test_method', ref_id: '' },
        { option: 2, combo_name: 'test_pressure_type', ref_id: '' },
        { option: 3, combo_name: 'fluid_disposition', ref_id: '' },
        { option: 4, combo_name: 'flow_path', ref_id: '' },
      ]

      dataCombo.forEach((data) => {
        this.getComboOptionList({
          params: {
            form_id: 'well_test',
            combo_name: data.combo_name,
            ref_id: data.ref_id,
          },
        }).then((resp) => {
          resp.data.data.forEach((d) => {
            switch (data.option) {
              case 1:
                this.optionComboTestMethod.push({
                  value: d.comboId,
                  text: d.comboValue,
                })
                break
              case 2:
                this.optionComboTestPressureType.push({
                  value: d.comboId,
                  text: d.comboValue,
                })
                break
              case 3:
                this.optionComboTestFluidDisposition.push({
                  value: d.comboId,
                  text: d.comboValue,
                })
                break
              case 4:
                this.optionComboTestFlowPath.push({
                  value: d.comboId,
                  text: d.comboValue,
                })
                break
              default:
                break
            }
            // data.option.push({ value: d.comboId, text: d.comboValue })
          })
        })
      })
    },
    makeToast(msg) {
      this.$bvToast.toast(msg, {
        title: 'Notification',
        autoHideDelay: 5000,
        appendToast: false,
      })
    },
    onSubmit(evt) {
      evt.preventDefault()

      if (this.hasData) {
        // if intId is exist that means data has already at server
        // time to update
        const data = { ...this.form }
        this.updateActivityWellTest({ params: data }).then((resp) => {
          notify({ message: 'Data has been recorded.', width: 300 }, 'success', 5000)
        })
      } else {
        // time to insert
        const data = { ...this.form, submitId: this.submitId }
        this.addActivityWellTest({ params: data }).then((resp) => {
          this.hasData = true
          notify({ message: 'Data has been recorded.', width: 300 }, 'success', 5000)
        })
      }
    },
    onReset(evt) {
      evt.preventDefault()
      this.form = []
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    producedPriorChanged(val) {
      if (val === 1) {
        this.checkedProducedPrior = true
        this.form.productionDate = undefined
        this.form.oilRate = undefined
        this.form.gasRate = undefined
        this.form.waterRate = undefined
        this.form.steamRate = undefined
      } else {
        this.checkedProducedPrior = false
        this.form.productionDate = undefined
        this.form.oilRate = undefined
        this.form.gasRate = undefined
        this.form.waterRate = undefined
        this.form.steamRate = undefined
      }
    },
    injectionChanged(val) {
      if (val === 1) this.checkedInjection = true
      else {
        this.checkedInjection = false
        this.form.type = undefined
        this.form.temp = undefined
        this.form.press = undefined
        this.form.gasVolume = undefined
        this.form.liquidVolume = undefined
        this.form.gasRateInjection = undefined
        this.form.liquidRate = undefined
      }
    },
  },
}
</script>